import { seo } from '../seo';
export { RegisterDomainPage as default } from '../../src/pages/Product/RegisterDomainPage';
export const meta = () => seo('domains.search');
